module.exports = __webpack_public_path__ + "img/BOWTIE 3 RED.c8b7bf2.svg";